<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" @del="del" ref="SetBtn"></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="expToPKB(1)">{{$t('getapi[7242]')}}</el-button>
            <el-button type="primary" size="mini" @click="countNew">{{$t('getapi[7243]')}}</el-button>
            <!--<el-button type="primary" size="mini" @click="reflashData">{{$t('getapi[7244]')}}</el-button>-->
            <el-button type="primary" size="mini" @click="expToPKB(0)">{{$t('getapi[7245]')}}</el-button>
            <el-checkbox type="primary" size="mini" v-model="ShowCM00" @change="showCM00_change" style="margin-left: 15px;">
                {{$t('getapi[7246]')}}
            </el-checkbox>
        </div>
        <!--  :formatter="formatN2()" -->
        <div id="xpane-0">
        <vxe-table :data="dataBody" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight - reduceTableHeight" @checkbox-change="handleSelectionChange" stripe border resizable
                   ref="singleTable">
            <vxe-table-column type="checkbox" align="center" width="30"></vxe-table-column>

            <vxe-table-column v-for="item in dataHeader" :key="item._key" :field="item._key" :title="item._value" :align="item.align" :width="item.width" show-overflow="tooltip">
                <template scope="scope" >
                    <span v-if="item._key == 'order_status'">{{ scope.row.order_status | lanchange}}</span>
                    <span v-else-if="item._key == 'amount_closing'">{{ scope.row.amount_closing | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'amount_purchase'">{{ scope.row.amount_purchase | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'amount_pay'">{{ scope.row.amount_pay | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'amount_due'">{{ scope.row.amount_due | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'realtime_due'">{{ scope.row.realtime_due | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'rt_m00'">{{ scope.row.rt_m00 | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'rt_c00'">{{ scope.row.rt_c00 | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'rt_cm'">{{ scope.row.rt_cm | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'amount_deduction'">{{ scope.row.amount_deduction | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'sd_c00'">{{ scope.row.sd_c00 | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'sd_pay'">{{ scope.row.sd_pay | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'sd_last'">{{ scope.row.sd_last | thousandthpuramount}}</span>
                    <span v-else-if="item._key == 'sd_pay_n1'">{{ scope.row.sd_pay_n1 | thousandthpuramount}}</span>
                    <span v-else>{{ scope.row[item._key]}}</span>
                </template>
            </vxe-table-column>
        </vxe-table>
        </div>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight - reduceTableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[2023]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="单据编号" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="审核年度" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="审核月份" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[1196]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[1197]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="供应商账期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[1237]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="2021.03余额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="2021.04采购金额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="2021.04付款金额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="04.30余额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="最新支付金额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="最新期末余额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="最新未到期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="最新到期余额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="最新到期+未到期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="质量扣款"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="支付笔数"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="最后支付日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[1861]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="更新日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="发票数量" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="审核时间1"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="审核时间2"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="截止05.18账单日到期款"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="05.18账单日后付款"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="账期日后支付笔数"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="账期日后支付时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" label="上月账单日到期款"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[100, 200, 300, 400]" :page-size="100" :pager-count="5" layout="total, sizes, prev, pager, next, jumper"
                               :total="total"></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="Fin_Payment_Due" ref="ser" @getser="serclick"></serce>

        <el-dialog v-dialogDrag :visible.sync="showCountNew" :title="$t('getapi[7247]')" width="30%" :close-on-click-modal="false">
            <div style="margin: 8px">
                <tr>
                    <td style="width:120px">{{$t('getapi[7248]')}}</td>
                    <td style="width:180px">
                        <el-select filterable v-model="dataOrder.order_no" size="mini" @change="changeOrderNo">
                            <el-option v-for="item in arrDataOrder" :key="item.order_no" :label="item.order_no" :value="item.order_no"></el-option>
                        </el-select>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="createNewBalance" style="width: 140px" :disabled="!btn.create">{{$t('getapi[7249]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[7250]')}}</td>
                    <td>
                        <el-date-picker v-model="dataOrder.audit_date1" type="datetime" size="mini" style="width:100%"></el-date-picker>
                    </td>
                    <td>
                        <el-date-picker v-model="dataOrder.audit_date2" type="datetime" size="mini" style="width:100%"></el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[7251]')}}</td>
                    <td>
                        <el-date-picker v-model="dataOrder.order_date_pay" type="datetime" size="mini" style="width:100%"></el-date-picker>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="refreshBalance" :disabled="btn.create" style="width: 140px">{{$t('getapi[7252]')}}</el-button>
                    </td>
                </tr>
            </div>
            <div style="height:20px"></div>
            <div style="margin: 8px">
                <tr>
                    <td style="width:120px"></td>
                    <td style="width:180px">
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="delBalance" style="width: 140px">{{$t('getapi[7253]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </div>
            <div style="height:20px"></div>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name: '3_fpddue',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                dataHeader: [],
                dataBody: [],
                dataOrder: {
                    audit_year: '',
                    audit_month: '',
                    order_no: '',
                    audit_date1: '',
                    audit_date2: '',
                    order_date_pay: '',
                },
                TimeYM: '', // 账期年月
                TimePay: '', //最新支付
                TimeSD: '', //账单日
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                selectData: [], //选择的数据集合
                showCountNew: false,
                parm1: '',
                arrDataOrder: [], //账期列表
                btn: {
                    create: false
                },
                expDetail: {},
                ShowCM00: false,
                scrollTop:0,
            };
        },
        watch: {
            dataBody: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.getView()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            showCM00_change() {
                this.getView();
            },
            // formatN2({ row, column, cellValue }) {
            //     console.log(row);
            //     if (row.type == "N" && cellValue) {
            //         console.log(cellValue.toLocaleString());
            //         return cellValue.toLocaleString();
            //     }
            //     else {
            //         return cellValue;
            //     }
            // },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6608]"),this.$t("getapi[3836]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                if (that.selectData.length > 0) {
                    that.$refs.SetBtn.SetOneBtnEnable('del', true)
                }
                that.btnauthority()
            },
            btnauthority() {
                let that = this
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'Fin_Payment_Due');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }

                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    ShowCM00: that.ShowCM00
                };
                that.$http.urlpost('/FrmFPDDue/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataHeader = res.Titles;
                        that.dataBody = res.DataContent;
                        /*that.dataOrder = res.DueOrder[0];*/
                        if (res.DueOrder != null) {
                            that.expDetail = res.DueOrder[0]
                        }
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            reflashData(){

            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                let ids = "";
                for (let i = 0; i < that.selectData.length; i++) {
                    ids = ids + that.selectData[i].order_no + ",";
                }

                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }

                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: ids,
                    Param: datac,
                    ShowCM00: that.ShowCM00
                };


                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/FrmFPDDue/DataList/ExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            expToPKB(val) {
                let that = this
                let tip = ''
                if (val == 1) {
                    tip = that.$t('getapi[8887]')//'（仅导出到期款大于零的账期）'
                }
                that.$confirm(that.$t('getapi[8888]') + that.expDetail.order_no + that.$t('getapi[8889]') + that.expDetail.order_date_pay + tip, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[2052]'),
                    cancelButtonText: that.$t('getapi[2053]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            c_00: val,
                            audit_year: that.expDetail.audit_year,
                            audit_month: that.expDetail.audit_month
                        }
                        that.$http.urlpost('/FrmFPDDue/DataList/ToPKB', parm, function (res) {
                            if (res.Success == 1) {
                                let hrefurl = Common.Url + res.DataContent.URL;
                                window.open(hrefurl);
                            }
                        });
                    })
                    .catch(() => {

                    });
            },
            handleSelectionChange({ records }) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push(records[i]);
                }
                that.authority();
            },
            countNew() {
                let that = this
                that.showCountNew = true
                that.getYMList()
            },
            // 创建新账期
            createNewBalance() {
                let that = this;
                this.$confirm(that.$t('getapi[8890]') + that.dataOrder.order_no + that.$t('getapi[8891]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let that = this
                        let parm = {
                            PayTime: that.dataOrder.order_date_pay,
                            audit_year: that.dataOrder.audit_year,
                            audit_month: that.dataOrder.audit_month
                        }
                        that.$http.urlpost('/FrmFPDDue/Create', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 刷新账期与明细
            refreshBalance() {
                let that = this
                let parm = {
                    PayTime: that.dataOrder.order_date_pay,
                    audit_year: that.dataOrder.audit_year,
                    audit_month: that.dataOrder.audit_month
                }
                that.$http.urlpost('/FrmFPDDue/RefreshData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            // 删除账期
            delBalance() {
                let that = this
                this.$confirm(that.$t('getapi[8892]') + that.dataOrder.order_no + that.$t('getapi[8891]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$confirm(that.$t('getapi[8893]'), that.$t('getapi[194]'), {//删除账期，是否退回已记账的质量扣款，支付单据?
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let parm = {
                                    BreakOrder: 1,
                                    PayTime: that.dataOrder.order_date_pay,
                                    audit_year: that.dataOrder.audit_year,
                                    audit_month: that.dataOrder.audit_month
                                }
                                that.$http.urlpost('/FrmFPDDue/Delete', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    }
                                });
                            })
                            .catch(() => {
                                let parm = {
                                    BreakOrder: 0,
                                    PayTime: that.dataOrder.order_date_pay,
                                    audit_year: that.dataOrder.audit_year,
                                    audit_month: that.dataOrder.audit_month
                                }
                                that.$http.urlpost('/FrmFPDDue/Delete', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    }
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 删除明细
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$confirm(that.$t('getapi[8894]'), that.$t('getapi[194]'), {//删除账期后是否同时禁用供应商（禁用的供应商不再计算新账期）?
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let arr = []
                                for (let i = 0; i < that.selectData.length; i++) {
                                    arr = [...arr, {
                                        order_no: that.selectData[i].order_no,
                                        vender_code: that.selectData[i].vender_code
                                    }]
                                }
                                let parm = {
                                    Rows: arr,
                                    Disable: 1
                                }
                                that.$http.urlpost('/FrmFPDDue/DeleteRows', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    }
                                });
                            })
                            .catch(() => {
                                let arr = []
                                for (let i = 0; i < that.selectData.length; i++) {
                                    arr = [...arr, {
                                        order_no: that.selectData[i].order_no,
                                        vender_code: that.selectData[i].vender_code
                                    }]
                                }
                                let parm = {
                                    Rows: arr,
                                    Disable: 0
                                }
                                that.$http.urlpost('/FrmFPDDue/DeleteRows', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    }
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //账期列表
            getYMList() {
                let that = this
                that.arrDataOrder = [];
                let parm = {
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/FrmFPDOrder/YMList', parm, function (res) {
                    if (res.Success == 1) {
                        let arr = res.DataContent
                        that.arrDataOrder = arr
                        for (let i = 0; i < arr.length; i++) {
                            if (arr[i].order_status == '待创建') {
                                that.btn.create = true
                                that.getDataOrder(arr[i].order_no, arr[i].audit_year, arr[i].audit_month)
                            }
                        }
                    }
                });
            },
            getDataOrder(order_no, year, month) {
                let that = this
                let mon
                that.dataOrder.audit_year = year
                that.dataOrder.audit_month = month
                that.dataOrder.order_no = order_no
                let d = new Date(year, month, 1);//取当年当月中的第一天
                let lastDay = new Date(d.getTime() - 1000 * 60 * 60 * 24).getDate();//获取当月最后一天日期
                if (d.getMonth() < 10) {
                    mon = '0' + d.getMonth();
                } else {
                    mon = d.getMonth();
                }
                that.dataOrder.audit_date1 = d.getFullYear() + '-' + mon + '-' + "0" + d.getDate() + ' ' + "00" + ':' + "00" + ':' + "00";
                that.dataOrder.audit_date2 = d.getFullYear() + '-' + mon + '-' + lastDay + ' ' + 23 + ':' + 59 + ':' + 59;
                if (month != 12) {
                    let mon1 = parseInt(month) + 1
                    if (mon1 < 10) {
                        mon1 = '0' + mon1
                    }
                    that.dataOrder.order_date_pay = d.getFullYear() + '-' + mon1 + '-' + "0" + d.getDate() + ' ' + 23 + ':' + 59 + ':' + 59;
                    console.log(that.dataOrder.order_date_pay)
                } else {
                    that.dataOrder.order_date_pay = (parseInt(d.getFullYear()) + 1) + '-01-' + "0" + d.getDate() + ' ' + 23 + ':' + 59 + ':' + 59;
                }
            },
            // 选择最新账期区间
            changeOrderNo(data) {
                let that = this
                console.log(data)
                let flag = false
                for (let i = 0; i < that.arrDataOrder.length; i++) {
                    if (data == that.arrDataOrder[i].order_no) {
                        that.getDataOrder(that.arrDataOrder[i].order_no, that.arrDataOrder[i].audit_year, that.arrDataOrder[i].audit_month)
                        if (that.arrDataOrder[i].order_status == '待创建') {
                            flag = true
                        }
                    }
                }
                if (flag) {
                    that.btn.create = true
                } else {
                    that.btn.create = false
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;

        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>